import React, { useEffect, useState } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

import Audios from 'app/componentV4/Audios'
import Circular from 'app/componentV4/Loader/Circular'

import useTextToSpeech from './useTextToSpeech'

const TextToSpeech = (props) => {
  const {
    id,
    audioUrl,
    languageId,
    isStopAudio,
    isLoadingAudio,
    currentMusicPlaying,
  } = props
  const { formatMessage } = useIntl()

  const {
    state: { reAudioUrl, isReLoadingAudio },
    handleFetchAudio,
  } = useTextToSpeech()

  const [setAudio, isSetAudio] = useState(audioUrl)

  useEffect(() => {
    if (R.isNil(audioUrl)) isSetAudio(reAudioUrl)
    else if (!R.isNil(audioUrl) && !isLoadingAudio) isSetAudio(audioUrl)
    else return
  }, [audioUrl, isLoadingAudio, reAudioUrl])

  return (
    <>
      {R.isNil(setAudio) && !isLoadingAudio ? (
        <div className="flex flex-wrap mt-28 mb-5">
          <Typography className="text-grey-66 text-12 mr-3">
            {formatMessage({ id: 'audioPlayer.stillProcessing.text' })}
          </Typography>
          {isReLoadingAudio ? (
            <Circular color="secondary" size={12} />
          ) : (
            <button
              className="text-blue-primary text-12"
              onClick={() => handleFetchAudio(id, languageId)}
            >
              {formatMessage({
                id: 'audioPlayer.stillProcessing.checkNow.btn',
              })}
            </button>
          )}
        </div>
      ) : (
        <Audios
          audioUrl={setAudio}
          isStopAudio={isStopAudio}
          isLoadingAudio={isLoadingAudio}
          currentMusicPlaying={currentMusicPlaying}
        />
      )}
    </>
  )
}

TextToSpeech.propTypes = {
  id: PropTypes.number,
  audioUrl: PropTypes.string,
  isStopAudio: PropTypes.bool,
  languageId: PropTypes.number,
  isLoadingAudio: PropTypes.bool,
  currentMusicPlaying: PropTypes.array,
}

export default TextToSpeech
